import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Heading1,
  Heading2,
  Heading3,
  Span,
  Paragraph,
  LinkStyled,
} from '../../components/typography';
import { ItemTraverser, MomsChange } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

const kategorier = [

];

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Udenlandsk">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Udenlandske øl på fad</Heading1>
        </Col>
        <Col xs={12}>
          <Paragraph>
            I Danmark er udenlandsk øl blevet mere og mere populært i løbet af de sidste 10-15 år.
            Dansk øl har altid været en sikker vinder i de danske hjem, men i takt med at verden bliver mindre, ses der en stigende interesse for udenlandske øl - og med god grund.
            Her kan du nemlig være opdagelsesrejsende i en verden af smag og skønt skum, der adskiller sig markant fra de danske smagsnoter.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser includedCategories={['fadoelUdenlandsk']} display={ProductView1} showTypeFadoel filterLiterPrice filterFadkobling filterLiterSize />
      </RowProductView>
    </Container>

    {kategorier.map(
      (kategoriNavn) => {
        const kategori = kategoriNavn[0];
        const navn = kategoriNavn[1];
        const link = kategoriNavn[2];

        return (
          <React.Fragment>
            <Container mb white>
              <Row>
                <Col xs={12}>
                  <Heading3>Udenlandske {navn} fadøl</Heading3>
                  <Paragraph>Nedenstående ser du alle vores udenlandske {navn} fadøl. Du kan se hele vores sortiment af <LinkStyled anchor to={link}>{navn} fadøl her</LinkStyled>.</Paragraph>
                  <Span fontSize="12px">Priser <MomsChange />, uden pant</Span>
                </Col>
              </Row>
            </Container>
            <Container>
              <RowProductView>
                <ItemTraverser includedCategories={['fadoelUdenlandsk', kategori]} display={ProductView1} />
              </RowProductView>
            </Container>
          </React.Fragment>
        );
      },
    )}
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Rejs verden rundt med udenlandske øl</Heading2>
          <Paragraph>
            ...Endda uden at forlade Danmark. Udenlandske øl byder på eksotiske og anderledes smagsnoter, som vi ikke kender fra de danske øl og du kan tage på en spændende jordomrejse gennem de mange aromaer og smage, der findes i de forskellige varianter af øl.
            Hos Skafte.dk finder du rigtig mange typer af <LinkStyled to="/fadoel">fadøl</LinkStyled>, der passer til forskellige begivenheder, smagsløg og typer af mad.
          </Paragraph>
          <Paragraph>
            Udenlandsk øl vækker dine sanser, ved at skille sig ud på flere parametre - både smag, farve, aroma og følelse på tungen.
            Nedenfor kan du finde inspiration til hvilket land, du vil besøge først - måske skal du ligefrem på en længere verdensomspændende tur.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} lg={6}>
          <Heading3>Belgien</Heading3>
          <Paragraph>
            Belgien er ikke kun kendt for vafler og hos Skafte.dk finder du et bredt udvalg af belgisk øl, herunder Affligem, Hoegaarden, Leffe og Grimbergen.
            Leffe Blond byder på rig historie, der går tilbage til 1240 og er Belgiens mest populære klosterøl. Øllen har en fyldig og frugtig sødme og en rund, harmonisk fylde.
            Belgisk øl adskiller sig meget fra hinanden og spænder lige fra lys og frugtig til mørk og fyldig. Smag dig frem og find din favorit.
          </Paragraph>
        </Col>
        <Col xs={12} lg={6}>
          <Heading3>Holland</Heading3>
          <Paragraph>
            Fra Holland finder du den velkendte Heineken, der efterhånden er en klassiker i mange danske hjem og til events. Faktisk er Heineken et at de bedst kendte ølmærker i verden.
            Du mødes af en frisk aroma og en let sød smag, der nemt slukker tørsten.
          </Paragraph>
        </Col>
        <Col xs={12} lg={6}>
          <Heading3>Irland</Heading3>
          <Paragraph>
            Det er svært at sige Irland, uden at nævne Guinness og Murphy’s. Når du tager en tår, er du ikke i tvivl om, at du drikker en udenlandsk øl.
            Begge ølmærker er kendt for deres stout, der har en næsten sort nuance og en dyb karamelliseret smag med et strejf af sødme.
          </Paragraph>
        </Col>
        <Col xs={12} lg={6}>
          <Heading3>Tjekkiet</Heading3>
          <Paragraph>
            Vores sortiment af udenlandske øl byder på et bredt udvalg fra Tjekkiet, der henvender sig til mange forskellige smagsløg.
            De tjekkiske brygmetoder repræsenteres bl.a. af Merlin Tmavy, Démon, Platan, Flying Cloud og den velkendte Pilsner Urquell og øltyperne spænder mellem pilsner, mørk pilsner, sort pilsner og India Pale Ale (IPA), så der er massere af udfordre sanserne med.
          </Paragraph>
        </Col>
        <Col xs={12} lg={6}>
          <Heading3>Tyskland</Heading3>
          <Paragraph>
            Når det handler om udenlandsk øl, er det praktisk talt uundgåeligt ikke at tage en tur til Tyskland.
            Skafte.dk forhandler både Erdinger, Weihenstephaner, Franziskaner og Paulaner, der alle er en del af den tyske øl historie.
            Der er kun 6 ølmærker, der må sælge til den verdenskendte officielle Oktoberfest i München, hvoraf Franziskaner og Paulaner er iblandt og vi er heldige at kunne tilbyde netop disse.
          </Paragraph>
        </Col>
        <Col xs={12} lg={6}>
          <Heading3>USA</Heading3>
          <Paragraph>
            Hvis vi tager en tur over Atlanten, finder vi den kendte pilsner fra Budweiser, der står for hver 5. solgte øl i hele USA. Smagen er sprød og ren, mens farven er gylden og den gør sig godt til flere lejligheder. Hvis du er mere til IPA end pilsner, bør du prøve Founder&apos;s All Day IPA, der er en sprød øl med noter af grapefrugt og mandarin og en klar bitterhed i eftersmagen.
          </Paragraph>
        </Col>
        <Col xs={12}>
          <Paragraph>
            Foruden de nævnte lande og udenlandske øl, finder du hos Skafte.dk også et kæmpe udvalg fra Frankrig, England og mange flere.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Udenlandsk øl på fustage</Heading2>
          <Paragraph>
            Vores udenlandske øl på fustage findes i størrelser mellem 20-30 L, ligesom vores danske fadøl. De mange varianter henvender sig til enhver smag og vi har gjort et kæmpe forarbejde, ved at udvælge alle de bedste, så du med garanti kan finde en (eller flere) der passer perfekt til din smag, event, lejlighed eller din aftensmad.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Alverdens udenlandske øl - leveret direkte til døren i Danmark</Heading2>
          <Paragraph>
            Hvis du heller ikke kan vente med at komme på en jordomrejse og blive introduceret til en verden af smag, så bestil din fustage med udenlandsk øl allerede i dag. Hvis du bestiller inden for almindelig arbejdstid, leverer vi oftest inden for 1-2 dage og vi tilbyder endda gratis levering i Storkøbenhavn, hvis du bestiller mindst 40 L.
          </Paragraph>
          <Paragraph>
            Tilbage er der kun at sige: god rejse.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
